import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MenuItem, useMediaQuery } from '@material-ui/core';
import React, { lazy, memo, Suspense, useState } from 'react';
import IntlMessages from 'util/IntlMessages';
const LanguageDialog = lazy(() => import('../LanguageDialog'));

const LanguageSwitcher = () => {
    const isDesktop = useMediaQuery('(min-width:899px)');
    const [open, setOpen] = useState(false);

    const handleLanguageDialogOpen = () => {
        setOpen(true);
    };

    const handleLanguageDialogClose = () => {
        setOpen(false);
    };

    if (isDesktop) {
        return null;
    }

    return (
        <>
            <MenuItem onClick={handleLanguageDialogOpen}>
                <FontAwesomeIcon
                    className='mr-2'
                    icon={faLanguage as IconProp}
                />
                <IntlMessages id='shared.language' />
            </MenuItem>
            <Suspense fallback={null}>
                <LanguageDialog
                    open={open}
                    handleLanguageDialogClose={handleLanguageDialogClose}
                />
            </Suspense>
        </>
    );
};

export default memo(LanguageSwitcher);
